const STORAGE_KEY = 'yoda.changeModal.composerPinned';

/** Default: composer stays pinned outside the timeline scroller. */
export const DEFAULT_COMPOSER_PINNED = true;

export function loadComposerPinned(): boolean {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === null)
            return DEFAULT_COMPOSER_PINNED;
        if (raw === 'false')
            return false;
        if (raw === 'true')
            return true;
        return DEFAULT_COMPOSER_PINNED;
    } catch {
        return DEFAULT_COMPOSER_PINNED;
    }
}

export function saveComposerPinned(pinned: boolean): void {
    try {
        localStorage.setItem(STORAGE_KEY, pinned ? 'true' : 'false');
    } catch {
        // Ignore quota / private mode failures.
    }
}
